export default function isValidEmail(email) {
  // eslint-disable-next-line no-useless-escape
  // regex is the same as used in account registration on SS
  const re = /^[\w!#$%&'+/=?`{|}~^-]+(?:\.[\w!#$%&'*+/=?`{|}~^-]+)*@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,6}$/;
  return re.test(String(email).toLowerCase());
}
